import { render, staticRenderFns } from "./VerifiedSignature.vue?vue&type=template&id=153b419a&scoped=true&"
import script from "./VerifiedSignature.vue?vue&type=script&lang=js&"
export * from "./VerifiedSignature.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedSignature.vue?vue&type=style&index=0&id=153b419a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153b419a",
  null
  
)

export default component.exports